import {Injectable} from '@angular/core'
import {HttpClient, HttpParams} from '@angular/common/http'

import {Observable} from 'rxjs'
import {tap} from 'rxjs/operators'

import {Task} from './task.interface'
import {
  ApiSearchRequest,
  ApiSearchResponse,
} from '@app/core/services/api.interface'
import {LoggerService} from '@app/core/services/logger.service'

export {Task}

export interface GetTasksRequest extends ApiSearchRequest {}
export interface GetTasksResponse extends ApiSearchResponse<Task> {}

@Injectable()
export class TaskService {
  constructor(
    private http: HttpClient,
    private logger: LoggerService,
  ) {}

  public getTasks(request: GetTasksRequest) {
    const url = 'api://Batch'

    let params = new HttpParams()
    if (request.search) {
      params = params.set('search', request.search)
    }
    if (request.sort) {
      params = params
        .set('sort', request.sort)
        .set('asc', !request.asc ? 'false' : 'true')
    }
    if (request.offset) {
      params = params.set('offset', request.offset.toString())
    }
    if (request.results) {
      params = params.set('results', request.results.toString())
    }

    return this.http.get<GetTasksResponse>(url, {params: params}).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public getTaskTypes() {
    return this.http.get<string[]>('api://Batch/Types')
  }

  public getTask(id: string): Observable<Task> {
    const url = 'api://Batch/' + id
    return this.http.get<Task>(url)
  }

  public getTaskFile(id: string, filename: string) {
    const url = 'api://Batch/' + id + '/' + filename
    return this.http.get(url, {responseType: 'blob'})
  }

  public postTask(
    type: string,
    parameters: object,
    file: File,
  ): Observable<void> {
    const url = 'api://Batch/'
    const task = {type: type, parameters: parameters}
    const body = new FormData()
    body.append(
      'task',
      new Blob([JSON.stringify(task)], {type: 'application/json'}),
    )
    body.append('file', file)

    // Note, this fixes an issue with the PWA-service-worker not passing files
    // add a bogus query variable
    let params = new HttpParams().set('x', '')

    return this.http.post<void>(url, body, {params: params}).pipe(
      tap((result) => {
        this.logger.log(result)
      }),
    )
  }
}
